import React, { FC } from 'react';

import Box from '@rover/kibble/core/Box';

const a11yHidden = {
  border: '0',
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: '0',
  position: 'absolute',
  width: '1px',
};

type Props = Omit<React.ComponentProps<typeof Box>, 'sx'>;

const A11yHiddenBox: FC<Props> = ({ children, ...other }) => (
  <Box {...other} sx={a11yHidden}>
    {children}
  </Box>
);

export default A11yHiddenBox;
